// extracted by mini-css-extract-plugin
module.exports = {"input":"inputNumberFront_input__2zWbQ","arrowBlock":"inputNumberFront_arrowBlock__2n_LD","arrows":"inputNumberFront_arrows__1KuiN","content":"inputNumberFront_content__12Sp0"};
    if(module.hot) {
      // 1790670319465
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  